// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__WBNOc","logo":"MainNavigation_logo__WmpoS","badge":"MainNavigation_badge__HKrZj"};